import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCaseContext } from '../context/CaseContext';
import '../mobile.css';

const MobileVerifiedCSDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fullFIR } = useCaseContext();
  const fir = location.state?.fir || fullFIR;
  const discrepancies = fir?.chargeSheet?.discrepancies;

  if (!fir || !discrepancies) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No verified charge sheet available yet.</p>;

  return (
    <div>
      <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#094268', marginBottom: '15px' }}>Verified Charge Sheet</h2>

      {discrepancies.map((text, i) => (
        <div key={i} className="m-card">{i + 1}. {text}</div>
      ))}

      <button
        className="m-button-primary"
        style={{ width: 'auto', padding: '10px 16px', marginTop: '10px' }}
        onClick={() => navigate('/m/fir/chargesheet/new', { state: { fir } })}
      >
        Re-verify
      </button>
    </div>
  );
};

export default MobileVerifiedCSDetails;
